module.exports = __webpack_public_path__ + "img/map_type01.6dc89ead.png";